module.exports = __webpack_public_path__ + "img/sl.18e65344.svg";